export enum PlaylistType {
    Unknown = "Unknown",
    Artists = "Artists",
    Albums = "Albums",
    Tracks = "Tracks",
}
